module.exports = __webpack_public_path__ + "static/media/close_icon.162602bc.png";